class LiveWidget extends HTMLElement {
  constructor() {
    super();
    this.overlay = this.querySelector('[data-live-overlay]');
    this.modal = this.querySelector('[data-live-modal]');
    this.trigger = this.querySelector('[data-live-trigger]');
    this.closeBtn = this.querySelector('[data-live-close]');
    this.iframe = this.querySelector('[data-live-iframe]');
    this.header = this.querySelector('[data-live-header]');
    this.embedBase = this.dataset.embedUrl || '';
    this.isDragging = false;
    this.dragOffset = { x: 0, y: 0 };
    this.isDesktop = window.matchMedia('(min-width: 750px)').matches;
  }

  connectedCallback() {
    if (!this.trigger || !this.overlay) return;

    this.trigger.addEventListener('click', () => this.open());
    this.closeBtn?.addEventListener('click', () => this.close());
    this.overlay.addEventListener('click', (event) => {
      if (event.target === this.overlay) this.close();
    });
    document.addEventListener('keydown', this.onKeydown);
    this.header?.addEventListener('pointerdown', this.onDragStart);
    window.addEventListener('resize', this.onResize);
  }

  disconnectedCallback() {
    document.removeEventListener('keydown', this.onKeydown);
    window.removeEventListener('resize', this.onResize);
    this.header?.removeEventListener('pointerdown', this.onDragStart);
  }

  onKeydown = (event) => {
    if (event.key === 'Escape' && this.overlay?.classList.contains('is-open')) {
      this.close();
    }
  };

  onResize = () => {
    this.isDesktop = window.matchMedia('(min-width: 750px)').matches;
    if (!this.isDesktop && this.modal) {
      this.modal.style.transform = '';
      this.modal.style.left = '';
      this.modal.style.top = '';
    }
  };

  open() {
    if (!this.overlay || !this.iframe || !this.embedBase) return;

    this.iframe.src = `${this.embedBase}?autoplay=1&rel=0&playsinline=1`;
    this.overlay.classList.add('is-open');
    this.overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    this.closeBtn?.focus();
  }

  close() {
    if (!this.overlay || !this.iframe) return;

    this.overlay.classList.remove('is-open');
    this.overlay.setAttribute('aria-hidden', 'true');
    this.iframe.src = '';
    document.body.style.overflow = '';
    this.trigger?.focus();
  }

  onDragStart = (event) => {
    if (!this.isDesktop || !this.modal || event.target.closest('[data-live-close]')) return;

    event.preventDefault();
    this.isDragging = true;
    this.header?.classList.add('is-dragging');

    const rect = this.modal.getBoundingClientRect();
    this.dragOffset.x = event.clientX - rect.left;
    this.dragOffset.y = event.clientY - rect.top;

    this.modal.style.transform = 'none';
    this.modal.style.left = `${rect.left}px`;
    this.modal.style.top = `${rect.top}px`;

    document.addEventListener('pointermove', this.onDragMove);
    document.addEventListener('pointerup', this.onDragEnd);
  };

  onDragMove = (event) => {
    if (!this.isDragging || !this.modal) return;

    const maxX = window.innerWidth - this.modal.offsetWidth;
    const maxY = window.innerHeight - this.modal.offsetHeight;
    const nextX = Math.min(Math.max(event.clientX - this.dragOffset.x, 0), maxX);
    const nextY = Math.min(Math.max(event.clientY - this.dragOffset.y, 0), maxY);

    this.modal.style.left = `${nextX}px`;
    this.modal.style.top = `${nextY}px`;
  };

  onDragEnd = () => {
    this.isDragging = false;
    this.header?.classList.remove('is-dragging');
    document.removeEventListener('pointermove', this.onDragMove);
    document.removeEventListener('pointerup', this.onDragEnd);
  };
}

customElements.define('live-widget', LiveWidget);
